<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <!-- {{selectedProduct}}
            {{selectedContact}}
            <hr />-->
            <!-- {{keywordsOptions}} -->
            <!-- {{selectedKeywords}}
            <hr />
            {{formParam}}-->
            <!-- {{formParamScrapeSt}} -->
            <!-- {{isLoadingEditCopy}} -->
            <div class="col-md-6">
              <div class="col-md-12 profile-info-left">
                <div class="col-md-12">
                  <div class="form-group row">
                    <label class="col-form-label">
                      Title
                      <span class="text text-danger">*</span>
                    </label>
                    <input type="text" v-model="formParam.title" class="form-control" />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group row">
                    <label class="col-form-label">
                      Brand/Merek
                      <span class="text text-danger">*</span>
                    </label>
                    <multiselect
                      v-model="selectedContact"
                      id="ajax"
                      label="name"
                      track-by="id"
                      :placeholder="'Type to search Brand...'"
                      :multiple="true"
                      open-direction="bottom"
                      :custom-label="customLabel"
                      :options="contactOptions"
                      :searchable="true"
                      :loading="isLoading"
                      :internal-search="false"
                      :close-on-select="false"
                      :options-limit="300"
                      :limit="3"
                      :limit-text="limitText"
                      :max-height="600"
                      :show-no-results="true"
                      :hide-selected="true"
                      @search-change="asyncFind"
                      :show-labels="false"
                    >
                      <template slot="tag" slot-scope="{ option, remove }">
                        <span class="custom__tag">
                          <span>{{option.name}}</span>
                          <span class="custom__remove" @click="remove(option)">❌</span>
                        </span>
                      </template>
                      <template slot="clear" slot-scope="props">
                        <div
                          class="multiselect__clear"
                          v-if="selectedContact.length"
                          @mousedown.prevent.stop="clearAll(props.search)"
                        ></div>
                      </template>
                      <span slot="noResult">Oops! No elements found.</span>
                    </multiselect>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group row">
                    <label class="col-form-label">
                      Product
                      <span class="text text-danger">*</span>
                    </label>
                    <multiselect
                      v-show="(selectedContact.length || showProduct==true)"
                      v-model="selectedProduct"
                      id="ajax"
                      label="name"
                      track-by="id"
                      :placeholder="'Type to search Product...'"
                      :multiple="true"
                      open-direction="bottom"
                      :custom-label="customLabel"
                      :options="productOptions"
                      :searchable="true"
                      :loading="isLoading"
                      :internal-search="false"
                      :close-on-select="false"
                      :options-limit="300"
                      :limit="3"
                      :limit-text="limitText"
                      :max-height="600"
                      :show-no-results="true"
                      :hide-selected="true"
                      @search-change="asyncFindProduct"
                      :show-labels="false"
                    >
                      <template slot="tag" slot-scope="{ option, remove }">
                        <span class="custom__tag">
                          <span>{{option.name}}</span>
                          <span class="custom__remove" @click="remove(option)">❌</span>
                        </span>
                      </template>
                      <template slot="clear" slot-scope="props">
                        <div
                          class="multiselect__clear"
                          v-if="selectedProduct.length"
                          @mousedown.prevent.stop="clearAll(props.search)"
                        ></div>
                      </template>
                      <span slot="noResult">Oops! No elements found.</span>
                    </multiselect>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="col-md-12">
                <!-- {{selectedKeywords}} -->
                <!-- <hr />
                {{selectedKeywordsArr}} -->
                <label class="col-form-label">
                  Keywords (Max: {{limitSelectedKeywords}})
                  <span class="text text-danger">*</span>
                </label>
                <multiselect
                  v-model="selectedKeywords"
                  id="ajax"
                  label="name"
                  track-by="id"
                  :placeholder="''"
                  :multiple="true"
                  :custom-label="customLabel"
                  :options="keywordsOptions"
                  :searchable="true"
                  :loading="isLoading"
                  :internal-search="false"
                  :close-on-select="false"
                  :options-limit="300"
                  :limit="3"
                  :limit-text="limitText"
                  :max-height="600"
                  :show-no-results="true"
                  @search-change="asyncFindKeywords"
                  :taggable="true"
                  @tag="addKeywords"
                  @select="dispatchSelectOption"
                  @remove="removeKeywords"
                >
                  <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                      <span>{{ option.name }}</span>
                      <span class="custom__remove" @click="remove(option)">❌</span>
                    </span>
                  </template>
                  <template slot="clear" slot-scope="props">
                    <div
                      class="multiselect__clear"
                      v-if="selectedContact.length"
                      @mousedown.prevent.stop="clearAll(props.search)"
                    ></div>
                  </template>
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
              </div>
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label">
                      Range Harga
                    </label>
                  </div>
                  <div class="col-md-6">
                    <input v-model="formParam.min_price" type="number" min="0" class="form-control" />
                  </div>
                  <div class="col-md-6">
                    <input v-model="formParam.max_price" type="number" min="0" class="form-control" />
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label">
                      Urutkan
                      <span class="text text-danger">*</span>
                    </label>
                    <select v-model="formParam.sort_by" class="form-control">
                      <option
                        v-for="(row,idx) in dataSortByListMarketplace"
                        :value="row.id"
                        :key="idx"
                      >{{row.label}}</option>
                      <!-- <option>Terbaru</option>
                      <option>Terlaris</option>
                      <option>Harga: Rendah ke Tinggi</option>
                      <option>Harga: Tinggi ke Rendah</option>-->
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

export default {
  components: {
    Skeleton,
    Multiselect
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showProduct: false,
      limitSelectedKeywords: 2,
      selectedKeywords: [],
      // selectedKeywordsArr: [],
      keywordsOptions: [],
      keywordsListParam: {
        name: "",
        page: 0,
        perPage: 20
      },
      dataSortByListMarketplace: [],
      selectedProduct: [],
      productOptions: [],
      productListParam: {
        brand_id: "",
        name: "",
        page: 0,
        perPage: 20
      },
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        name: "",
        page: 0,
        perPage: 20
      },
      isSending: false,
      dataListMonitoringStatus: [],
      dataListMarketplace: [],
      formParam: {
        title: "",
        keywords_id: [],
        brand_id: "",
        mp_product_master_id: "",
        min_price: "",
        max_price: "",
        sort_by: "price_desc",
        order_by: ""
      },
      isLoading: false
    };
  },
  watch: {
    formParamScrapeSt: {
      handler: async function(val, oldVal) {
        if (val != oldVal && val.id != "") {
          // console.log("oldVal", oldVal);
          // console.log("newVal", val);
          // this.formValidate(val);

          let currentParam = {};
          currentParam.title = val.title;
          let copy = this.$route.query.copy;
          if (typeof copy != "undefined" && copy == "1") {
            currentParam.title = currentParam.title +" - COPY";
          }
          currentParam.mp_product_master_id = val.mp_product_master_id;
          currentParam.keywords_id = val.keywords_id;
          currentParam.min_price = val.min_price;
          currentParam.max_price = val.max_price;
          if (val.sort_by == "price" && val.order_by == "asc") {
            currentParam.sort_by = "price_asc";
          } else if (val.sort_by == "price" && val.order_by == "desc") {
            currentParam.sort_by = "price_desc";
          } else {
            currentParam.sort_by = val.sort_by;
          }
          this.formParam = currentParam;

          this.selectedKeywords = [];
          // this.selectedKeywordsArr = [];
          val.keywords_id.forEach(async (keywordId, idx) => {
            this.$store
              .dispatch("monitoring/detailKeywords", keywordId) // sesuai kan dengan method di API
              .then(async responseDet => {
                var resData = responseDet.data;
                this.selectedKeywords.push(resData);
                // this.selectedKeywordsArr.push({id:resData,is_selected:true})
              });
          });

          this.showProduct = true;
          let brandId = "0";
          // this.selectedProduct = await [];
          await this.$store
            .dispatch(
              "brandProduct/detail",
              this.formParam.mp_product_master_id
            ) // sesuai kan dengan method di API
            .then(responseDet => {
              var resDataProd = responseDet.data;
              // console.log("seeeel", this.selectedProduct);
              brandId = resDataProd.brand_id;
              // this.selectedContact = [];
              this.$store
                .dispatch("brand/detail", brandId) // sesuai kan dengan method di API
                .then(responseDetBrand => {
                  var resData = responseDetBrand.data;
                  this.selectedContact.push(resData);
                  var that = this;
                  setTimeout(function() {
                    that.selectedProduct.push(resDataProd);
                    that.formParam.mp_product_master_id = resDataProd.id;
                    currentParam.mp_product_master_id = that.formParam.mp_product_master_id =
                      that.selectedProduct.id;
                  }, 100);
                });
            });
          // this.formValidate(currentParam);

          // console.log("currentParam", currentParam);
          // currentParam.sort_by = val.sort_by;
          // currentParam.order_by = val.order_by;
        }
      },
      deep: true
    },
    formParam: {
      handler: function(val, oldVal) {
        // if (val != oldVal) {
        // console.log("oldVal", oldVal);
        // console.log("newVal", val);
        this.formValidate(val);
        // }
      },
      deep: true
    },
    selectedProduct: {
      handler: function(val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedProduct = val;
        }
        if (val.length == 1) {
          this.formParam.mp_product_master_id = val[0].id;
          // this.searchData();
        } else {
          this.formParam.mp_product_master_id = "";
          // this.searchData();
        }
      },
      deep: true
    },
    selectedContact: {
      handler: function(val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedContact = val;
          // this.asyncFindProduct()
        }
        if (val.length == 1) {
          this.productOptions = [];
          this.selectedProduct = [];
          this.formParam.brand_id = val[0].id;
          this.asyncFindProduct();
          // this.searchData();
        } else {
          this.productOptions = [];
          this.selectedProduct = [];
          this.formParam.brand_id = "";
          // this.searchData();
        }
      },
      deep: true
    },
    activeIndex: {
      handler: function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          // this.selectedLicense = [];
          var that = this;
          setTimeout(function() {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            // that.formParam = that.formParamSt;
            // if (val == 0) {
            //   that.asyncFind();
            //   that.getMonitoringSortByList()
            // }
            // that.asyncFindProduct();
            // console.log("")
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    formParamScrapeSt() {
      return this.$store.state.monitoring.formParamScrapeSt;
    }
    // isShowForm() {
    //   return this.$store.state.monitoring.isShowForm;
    // }
  },
  filters: {
    capitalising: function(data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  methods: {
    formValidate(currentParam) {
      // let newParam = {
      //   title: "",
      //   mp_product_master_id: "",
      //   keywords_id: [],
      //   min_price: 0,
      //   max_price: 0,
      //   sort_by: "price",
      //   order_by: "desc"
      // };
      let newParam = this.formParamScrapeSt;
      //   newParam = currentParam;
      newParam.title = currentParam.title;
      newParam.mp_product_master_id = currentParam.mp_product_master_id;
      // newParam.keywords_id = currentParam.keywords_id;
      newParam.keywords_id = this.selectedKeywords;
      newParam.min_price = parseInt(currentParam.min_price);
      newParam.max_price = parseInt(currentParam.max_price);

      if (currentParam.sort_by != "") {
        switch (currentParam.sort_by) {
          case "price_asc":
            newParam.sort_by = "price";
            newParam.order_by = "asc";
            break;
          case "price_desc":
            newParam.sort_by = "price";
            newParam.order_by = "desc";
            break;
          default:
            newParam.sort_by = currentParam.sort_by;
            newParam.order_by = "";
            break;
        }
      }
      this.$store.dispatch("monitoring/actFormParamScrapeSt", newParam);
      //   console.log("newParam", newParam);
    },
    spliceMultidimensionalByKey(arr, keyToMatch, valueToMatch) {
      for (let i = 0; i < arr.length; i++) {
        // Assuming each sub-array is an object or an array of objects
        // If it's an array of objects:
        if (Array.isArray(arr[i])) {
          for (let j = 0; j < arr[i].length; j++) {
            if (arr[i][j] && arr[i][j][keyToMatch] === valueToMatch) {
              arr[i].splice(j, 1); // Remove 1 element at index j
              return true; // Element found and removed
            }
          }
        } 
        // If it's an object directly within the main array:
        else if (arr[i] && arr[i][keyToMatch] === valueToMatch) {
          arr.splice(i, 1); // Remove 1 element at index i
          return true; // Element found and removed
        }
      }
      return false; // Element not found
    },
    async removeKeywords(tag) {
      if (this.formParam.keywords_id.length) {
        var index = this.formParam.keywords_id.indexOf(tag.id);
        if (index !== -1) {
          this.formParam.keywords_id.splice(index, 1);
        }
        if (this.selectedKeywords != null) {
          var that = this;
          setTimeout(function() {
            var index2 = that.selectedKeywords
              .map(x => {
                return x.id;
              })
              .indexOf(tag.id);
            // console.log("index2", index2);

            if (index2 >= 0) {
              that.selectedKeywords.splice(index2, 1);
              // that.spliceMultidimensionalByKey(this.selectedKeywordsArr,'id',index2)
            }
          }, 300);
        }
      }
      //   console.log("removekyeowrd", tag);
      //   console.log("selectedKeywords", this.selectedKeywords);
    },
    dispatchSelectOption(optionSelected) {
      if (this.formParam.keywords_id.length == this.limitSelectedKeywords) {
        this.$fire({
          title: "Error Keywords",
          text: "Only allowed 2 keywords at this moment",
          type: "error",
          timer: 2000
        });
        this.removeKeywords(optionSelected);
        return false;
      }
      let idTag = optionSelected.id;
      this.formParam.keywords_id.push(idTag.toString());
    },
    async addKeywords(newTag) {
      //   console.log("newTag", newTag);
      //   console.log("selectedCont", this.selectedKeywords);
      let formParam = {
        id: "",
        name: newTag
      };
      this.isSending = await true;

      await this.$store
        .dispatch("monitoring/addKeywords", formParam)
        .then(response => {
          var { data } = response;
          this.isSending = false;
          this.selectedKeywords.push(data);
          // this.selectedKeywordsArr.push({id:data,is_selected:true});
          this.keywordsOptions.push(data);
          //validasi
          this.dispatchSelectOption(data);
        })
        .catch(() => {
          this.isSending = false;
        });
    },
    asyncFindKeywords(query) {
      this.isLoading = true;
      this.keywordsListParam.name = query;
      this.$store
        .dispatch("monitoring/listKeywords", this.keywordsListParam)
        .then(response => {
          this.isLoading = false;
          this.keywordsOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    getMonitoringSortByList() {
      this.isLoading = true;
      this.$store
        .dispatch("monitoring/getMonitoringSortByList")
        .then(response => {
          this.isLoading = false;
          this.dataSortByListMarketplace = response.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    asyncFindProduct(query) {
      if (this.selectedContact.length < 1) {
        return;
      }
      this.isLoading = true;
      this.productListParam.name = query;
      // console.log("selectedContact", this.selectedContact);
      this.productListParam.brand_id = this.selectedContact[0].id;
      this.$store
        .dispatch("brandProduct/list", this.productListParam)
        .then(response => {
          this.isLoading = false;
          this.productOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ name }) {
      return `${name}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.$store
        .dispatch("brand/list", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    clearAll() {
      this.selectedContact = [];
    }
  },
  async created() {
    this.asyncFind();
    this.getMonitoringSortByList();
    this.$root.$on(
      "on-validate",
      validationResult => {
        console.log("validationResult", validationResult);
      },
      activeTabIndex => {
        console.log("activeTabIndex", activeTabIndex);
      }
    );
  },
  beforeDestroy() {},
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>


// WEBPACK FOOTER //
// src/views/monitoring/scrape/components/form1.vue